import ACTION_TYPE from 'components/../redux/actions/actionTypes';
import ApiHelper from 'utils/apiHelper';
import { API_URL } from 'utils/constants';

export const getDevices = (params) => (dispatch, getState) => {
    const { searchParams } = getState().devices;
    dispatch({ type: ACTION_TYPE.SEARCH_DEVICES_REQ });
    const timezoneOffSet = new Date().getTimezoneOffset();
    ApiHelper.get(
        API_URL.DEVICE_SEARCH,
        {},
        {},
        {
            ...searchParams,
            ...params,
            tz: -timezoneOffSet
        }
    )
        .then((res) => {
            dispatch({
                type: ACTION_TYPE.SEARCH_DEVICES,
                data: res.data
            });
        })
        .catch((err) => {
            dispatch({
                type: ACTION_TYPE.SEARCH_DEVICES_FAILED,
                data: err.response.message
            });
        });
};

export const updateSearchParams = (params) => (dispatch) => {
    dispatch({ type: ACTION_TYPE.SEARCH_PARAM_UPDATE, data: params });
};
